export default __webpack_public_path__ + "static/Andrii-Petryk-9291d6a336402112e775e549f246dd7c.png";